import { h } from "preact";
import { useState } from "preact/hooks";
import { Modal, Form, Input, Button, message } from "antd";
import {useConsumers} from "./useConsumers.js";

export const NewConsumerModal = ({ visible, onClose, onSuccess }) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const { createConsumer } = useConsumers();

    const handleSubmit = async (values) => {
        try {
            setLoading(true);

            // Prepare the data for the API request
            const consumerData = {
                contact_person_full_name: values.contactPersonFullName,
                contact_person_email: values.contactPersonEmail,
                contact_person_phone_number: values.contactPersonPhoneNumber,
                company: values.company,
                country: values.country,
                city: values.city,
                address: values.address,
                username: values.username,
                password: values.password
            };

            const response = await createConsumer({ consumerData });

            message.success("Consumer created successfully!");
            form.resetFields();
            onSuccess && onSuccess();
            onClose();

        } catch (error) {
            console.error("Error creating consumer:", error);

            if (error.response?.data?.message) {
                message.error(`Failed to create consumer: ${error.response.data.message}`);
            } else {
                message.error("Failed to create consumer. Please try again.");
            }
        } finally {
            setLoading(false);
        }
    };

    const handleCancel = () => {
        form.resetFields();
        onClose();
    };

    return (
        <Modal
            title="NEW CONSUMER"
            open={visible}
            onCancel={handleCancel}
            footer={null}
            width={800}
            destroyOnClose
        >
            <Form
                form={form}
                layout="vertical"
                onFinish={handleSubmit}
                style={{ marginTop: 24 }}
            >
                <Form.Item
                    label="CONTACT PERSON FULL NAME"
                    name="contactPersonFullName"
                    rules={[
                        { required: true, message: "Please enter contact person full name" }
                    ]}
                >
                    <Input
                        placeholder="John Doe"
                        size="large"
                    />
                </Form.Item>

                <Form.Item
                    label="CONTACT PERSON EMAIL"
                    name="contactPersonEmail"
                    rules={[
                        { required: true, message: "Please enter contact person email" },
                        { type: "email", message: "Please enter a valid email address" }
                    ]}
                >
                    <Input
                        placeholder="john@example.com"
                        size="large"
                    />
                </Form.Item>

                <Form.Item
                    label="CONTACT PERSON PHONE NUMBER"
                    name="contactPersonPhoneNumber"
                    rules={[
                        { required: true, message: "Please enter contact person phone number" }
                    ]}
                >
                    <Input
                        placeholder="+7 777 777 7777"
                        size="large"
                    />
                </Form.Item>

                <Form.Item
                    label="COMPANY"
                    name="company"
                    rules={[
                        { required: true, message: "Please enter company name" }
                    ]}
                >
                    <Input
                        placeholder="Microsoft Corporation"
                        size="large"
                    />
                </Form.Item>

                <Form.Item
                    label="COUNTRY"
                    name="country"
                    rules={[
                        { required: true, message: "Please enter country" }
                    ]}
                >
                    <Input
                        placeholder="Kazakhstan"
                        size="large"
                    />
                </Form.Item>

                <Form.Item
                    label="CITY"
                    name="city"
                    rules={[
                        { required: true, message: "Please enter city" }
                    ]}
                >
                    <Input
                        placeholder="Almaty"
                        size="large"
                    />
                </Form.Item>

                <Form.Item
                    label="ADDRESS"
                    name="address"
                    rules={[
                        { required: true, message: "Please enter address" }
                    ]}
                >
                    <Input
                        placeholder="Main Street, 123"
                        size="large"
                    />
                </Form.Item>

                <Form.Item
                    label="USERNAME"
                    name="username"
                    rules={[
                        { required: true, message: "Please enter username" },
                        { min: 3, message: "Username must be at least 3 characters" }
                    ]}
                >
                    <Input
                        placeholder="admin"
                        size="large"
                    />
                </Form.Item>

                <Form.Item
                    label="PASSWORD"
                    name="password"
                    rules={[
                        { required: true, message: "Please enter password" },
                        { min: 6, message: "Password must be at least 6 characters" }
                    ]}
                >
                    <Input.Password
                        placeholder="••••••••••••••"
                        size="large"
                    />
                </Form.Item>

                <Form.Item style={{ marginTop: 32, textAlign: "right" }}>
                    <Button
                        onClick={handleCancel}
                        style={{ marginRight: 16 }}
                        size="large"
                    >
                        Cancel
                    </Button>
                    <Button
                        type="primary"
                        htmlType="submit"
                        loading={loading}
                        size="large"
                        style={{
                            backgroundColor: "#617aff",
                            borderColor: "#617aff"
                        }}
                    >
                        Submit
                    </Button>
                </Form.Item>
            </Form>
        </Modal>
    );
};